import React, { useEffect, useState } from "react";
import { Link } from "@reach/router";
import { fetchInstances, encode } from "../utils/api";
import { StyledClubCard, Span } from "../styles/StyledClub";
import ErrorPopup from "./ErrorPopup";
function ClubProjectCard({ id, clubName, clientName, projectName, instances }) {
  const [value, setValue] = useState("NA");
  const [error, setError] = useState(null);
  const encoded = encode(clubName);
  const areas = [
    "peopleFirst",
    "clientManagement",
    "commercialManagement",
    "product",
    "delivery",
    "techQuality",
  ];
  useEffect(() => {
    if (instances.length > 0) {
      fetchInstances(encoded, id)
        .then((res) => {
          const latestInstance = Object.entries(res.at(-1));
          console.log(latestInstance);
          let total = 0;
          let count = 0;
          for (const arr of latestInstance) {
            for (const area of areas) {
              if (arr[0] === area) {
                for (const [key, value] of Object.entries(arr[1])) {
                  if (key === "score" && value !== null) {
                    count++;
                    total = total + value;
                  }
                }
              }
            }
          }
          const average = Math.round(total / count);
          if (isNaN(average)) setValue("NA");
          else setValue(average);
        })
        .catch((err) => {
          if (err) setError(err);
        });
    }
  }, [clubName, id, instances.length, encoded, areas]);
  const title = projectName ? `${clientName} - ${projectName}` : clientName;
  return (
    <StyledClubCard>
      {error && <ErrorPopup errors={error.response.data.errors} />}

      <h3>{title}</h3>
      <div className="span">
        <Span value={value}>{value}</Span>
      </div>
      <Link
        state={{
          id: id,
          projectName: projectName,
          clubName: clubName,
          clientName: clientName,
        }}
        to={`/project/${id}`}
      >
        <button>View Project</button>
      </Link>
    </StyledClubCard>
  );
}

export default ClubProjectCard;
